import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '@Root/slices'

export default function useBrowser() {
  const dispatch = useDispatch()
  const browser = useSelector((state: RootState) => state.browser)

  return { browser, ...browser }
}
